
import React from 'react';

import Extrusionmolding from './Extrusionmolding';
import Exhibitionmodel from './Exhibitionmodel';
import Plasticizinglways from './Plasticizinglways';
import Extrusiontables from './Extrusiontables';


const Extrusionblowmol = () => {
    return (
        <div>
            <Extrusionmolding />
            <Exhibitionmodel />
            <Plasticizinglways />
            <Extrusiontables />

        </div>
    );
};

export default Extrusionblowmol;
